import React from "react"
import PropTypes from "prop-types"

import Link from "../utils/link"

import FooterInstagram from "./FooterIcons/Instagram"
import FooterFacebook from "./FooterIcons/Facebook"
// import FooterTwitter from "./FooterIcons/Twitter"
import SubscribeNewsletterForm from "./SubscribeNewsletterForm"

import footerLogo from "../assets/images/Icons/logo-footer.svg"
import "./footer.scss"

const Footer = ({ socialPost }) => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <Link to="/" title="rocc">
          <img src={footerLogo} className="footer__logo" />
        </Link>
        <p className="footer__copyrights--pc ">
          &#169;Copyright – ROCC Naturals 2021.
        </p>
        <ul className="footer__links">
          <li>
            <Link
              to="/privacy-policy"
              title="privacy policy"
              className="footer__link"
            >
              privacy policy
            </Link>
          </li>

          <li>
            <Link
              to="/delivery-details"
              className="footer__link"
              title="/delivery details"
            >
              shipping + returns
            </Link>
          </li>

          <li>
            <Link to="/returns" className="footer__link" title="returns">
              returns
            </Link>
          </li>

          <li>
            <Link
              to="/terms-of-service"
              className="footer__link"
              title="terms and conditions"
            >
              terms & conditions
            </Link>
          </li>
        </ul>
        <ul className="footer__icons">
          {socialPost && (
            <li>
              <Link
                to={socialPost.socialMediaLinks.instagram}
                target="__blank"
                title="instagram"
                className="footer__icons__instagram"
              >
                <FooterInstagram />
              </Link>
            </li>
          )}
          {socialPost && (
            <li>
              <Link
                to={socialPost.socialMediaLinks.facebook}
                target="__blank"
                title="facebook"
                className="footer__icons__facebook"
              >
                <FooterFacebook />
              </Link>
            </li>
          )}
          {/* { socialPost &&
            <li>
              <Link
                to={socialPost.socialMediaLinks.twitter}
                target="__blank"
                title="twitter"
                className="footer__icons__twitter"
              >
                <FooterTwitter />
              </Link>
            </li>
          } */}
        </ul>
        <div className="footer__subscribe-form">
          <SubscribeNewsletterForm />
        </div>
        <p
          id="footerCopyright"
          className="footer__link  footer__copyrights--mobile"
        >
          &#169;Copyright ROCC Naturals 2021.
        </p>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  socialPost: PropTypes.object.isRequired,
}

export default Footer
